<mat-toolbar color="primary">
  <mat-toolbar-row class="container">
    <span>
      @if (detail) {
        {{ detail.candidate.name || detail.candidate.email }}
      }
    </span>
    <span class="modal-toolbar-spacer"></span>
    <button mat-icon-button class="ml-auto close-toolbar-btn" (click)="close()"
      [matTooltip]="'generic.buttons.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<mat-dialog-content class="p-0">
  @if (loading) {
    <div class="p-4">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  } @else if (detail) {
    <!-- Feedback utente (ridisegno UI in tab): stato/verifica restano visibili
         sopra le tab, contesto trasversale utile qualunque tab si stia guardando -
         l'identita' (nome/cognome/email) vive ora dentro la tab "Dettagli". -->
    @if (detail.engagement) {
      <div class="detail-badges p-4 pb-2">
        <app-clinical-onboarding-status-badge [macroStatus]="detail.engagement.macro_status"></app-clinical-onboarding-status-badge>
        <!-- Feedback utente: "la freccia [...] graficamente non va bene" - un
             bottone separato accanto al chip finiva "flottante" nello spazio tra
             i due chip. Ora e' il chip STESSO il trigger del menu (tutto un
             unico elemento cliccabile, la freccina e' il suo ultimo simbolo). -->
        <button type="button" class="verification-chip" [class.verification-ok]="verificationDisplay.statusClass === 'ok'"
          [class.verification-ko]="verificationDisplay.statusClass === 'ko'"
          [class.verification-neutral]="verificationDisplay.statusClass === 'neutral'"
          [matMenuTriggerFor]="verificationMenu" [disabled]="savingVerificationOverride"
          [matTooltip]="'components.clinical-onboarding.clinician-detail.verification-override-tooltip' | translate">
          <mat-icon>{{ verificationDisplay.icon }}</mat-icon>
          {{ verificationDisplay.labelKey | translate }}
          <mat-icon class="verification-chip-caret" [class.spin]="savingVerificationOverride">{{ savingVerificationOverride ? 'autorenew' : 'expand_more' }}</mat-icon>
        </button>
        <mat-menu #verificationMenu="matMenu">
          <button mat-menu-item (click)="setVerificationOverride(true)">
            <mat-icon>check_circle</mat-icon>
            <span>{{ 'components.clinical-onboarding.clinician-detail.mark-verification-valid' | translate }}</span>
          </button>
          <button mat-menu-item (click)="setVerificationOverride(false)">
            <mat-icon>cancel</mat-icon>
            <span>{{ 'components.clinical-onboarding.clinician-detail.mark-verification-invalid' | translate }}</span>
          </button>
          @if (detail.engagement.verification_override !== null) {
            <button mat-menu-item (click)="setVerificationOverride(null)">
              <mat-icon>restart_alt</mat-icon>
              <span>{{ 'components.clinical-onboarding.clinician-detail.clear-verification-override' | translate }}</span>
            </button>
          }
        </mat-menu>
        @if (!detail.candidate.imported) {
          <span class="not-imported-chip">
            <mat-icon>info</mat-icon>
            {{ 'components.clinical-onboarding.dashboard.not-imported-yet' | translate }}
          </span>
        }
        @if (detail.engagement.is_paid) {
          <span class="paid-chip">
            <mat-icon>paid</mat-icon>
            {{ 'components.clinical-onboarding.clinician-detail.paid-chip' | translate: { date: (detail.engagement.payment?.payment_date | date:'dd/MM/yyyy') } }}
          </span>
        }
        @if (detail.engagement.is_excluded) {
          <span class="excluded-chip">
            <mat-icon>block</mat-icon>
            {{ 'components.clinical-onboarding.clinician-detail.excluded-chip' | translate }}
          </span>
        }

      </div>
    }

    <mat-tab-group (selectedTabChange)="onTabChange($event)">
      <mat-tab [label]="'components.clinical-onboarding.clinician-detail.tab-detail' | translate">
        <div class="p-4">
          <form [formGroup]="identityForm" (ngSubmit)="saveIdentity()">
            <div class="row">
              <div class="col-md-6">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{ 'generic.name' | translate }}</mat-label>
                  <input matInput formControlName="name" maxlength="255">
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{ 'modals.register-clinical-onboarding-candidates.last-name' | translate }}</mat-label>
                  <input matInput formControlName="last_name" maxlength="255">
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                  <mat-label>{{ 'generic.email' | translate }}</mat-label>
                  <input matInput formControlName="email" type="email">
                  <mat-hint>{{ 'components.clinical-onboarding.clinician-detail.email-change-hint' | translate }}</mat-hint>
                </mat-form-field>
              </div>
            </div>
            @if (detail.engagement && detail.engagement.can_edit === false) {
              <p class="hint-text">{{ 'components.clinical-onboarding.clinician-detail.locked-after-payment-hint' | translate }}</p>
            }
            <div class="d-flex justify-content-end">
              <button mat-raised-button color="primary" type="submit"
                [disabled]="savingIdentity || (detail.engagement && detail.engagement.can_edit === false)">
                {{ 'generic.buttons.save' | translate }}
              </button>
            </div>
          </form>
        </div>
      </mat-tab>

      <mat-tab [label]="'components.clinical-onboarding.clinician-detail.contract-data' | translate">
        <div class="p-4">
          @if (detail.engagement) {
            <div class="d-flex justify-content-end mb-3">
              <!-- Feedback utente: "rendere modificabili da parte dell'amministratore
                   tutti i campi dati di un clinico" - il pannello era interamente in
                   sola lettura, l'unico modo di correggere questi dati era che lo
                   facesse il clinico stesso dal proprio wizard. -->
              <button mat-stroked-button color="primary" [disabled]="detail.engagement.can_edit === false" (click)="openEditData()">
                <mat-icon class="mr-1">edit</mat-icon>
                {{ 'generic.edit' | translate }}
              </button>
            </div>
            @if (detail.engagement.can_edit === false) {
              <p class="hint-text">{{ 'components.clinical-onboarding.clinician-detail.locked-after-payment-hint' | translate }}</p>
            }
            <!-- Bug: la sintesi mostrava solo 4 campi su tutti quelli che il form
                 di modifica gestisce - title/employer_type/pa_authorization_status
                 e presenza di IBAN/codice fiscale erano visibili SOLO aprendo
                 "Modifica". Ora la sintesi in sola lettura copre tutti i campi. -->
            <div class="engagement-summary">
              <div class="summary-field">
                <span class="summary-label">{{ 'components.clinical-onboarding.wizard.field-title' | translate }}</span>
                <span class="summary-value">{{ detail.engagement.title || '-' }}</span>
              </div>
              <div class="summary-field">
                <span class="summary-label">{{ 'components.clinical-onboarding.wizard.field-employer-type' | translate }}</span>
                <span class="summary-value">
                  @if (detail.engagement.employer_type) {
                    {{ 'components.clinical-onboarding.employer-type.' + i18nKeySuffix(detail.engagement.employer_type) | translate }}
                  } @else {
                    -
                  }
                </span>
              </div>
              <div class="summary-field">
                <span class="summary-label">{{ 'components.clinical-onboarding.wizard.field-employer-name' | translate }}</span>
                <span class="summary-value">{{ detail.engagement.employer_name || '-' }}</span>
              </div>
              <div class="summary-field">
                <span class="summary-label">{{ 'components.clinical-onboarding.clinician-detail.field-pa-authorization' | translate }}</span>
                <span class="summary-value">
                  @if (detail.engagement.pa_authorization_status) {
                    {{ 'components.clinical-onboarding.pa-authorization-status.' + i18nKeySuffix(detail.engagement.pa_authorization_status) | translate }}
                  } @else {
                    -
                  }
                </span>
              </div>
              <div class="summary-field">
                <span class="summary-label">{{ 'components.clinical-onboarding.wizard.field-iban' | translate }}</span>
                <span class="summary-value sensitive-value">
                  @if (revealedValues.iban) {
                    <code class="revealed-value">{{ revealedValues.iban }}</code>
                    <button mat-icon-button type="button" (click)="copySensitiveField('iban')" [matTooltip]="'components.clinical-onboarding.clinician-detail.copy' | translate">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                    <button mat-icon-button type="button" (click)="hideSensitiveField('iban')" [matTooltip]="'components.clinical-onboarding.clinician-detail.hide' | translate">
                      <mat-icon>visibility_off</mat-icon>
                    </button>
                  } @else {
                    {{ (detail.engagement.has_iban ? 'generic.yes' : 'generic.no') | translate }}
                    @if (detail.engagement.has_iban) {
                      <button mat-icon-button type="button" [disabled]="revealingField !== null" (click)="revealSensitiveField('iban')" [matTooltip]="'components.clinical-onboarding.clinician-detail.reveal' | translate">
                        <mat-icon [class.spin]="revealingField === 'iban'">{{ revealingField === 'iban' ? 'autorenew' : 'visibility' }}</mat-icon>
                      </button>
                    }
                  }
                </span>
              </div>
              <div class="summary-field">
                <span class="summary-label">{{ 'components.clinical-onboarding.wizard.field-tax-code' | translate }}</span>
                <span class="summary-value sensitive-value">
                  @if (revealedValues.tax_code) {
                    <code class="revealed-value">{{ revealedValues.tax_code }}</code>
                    <button mat-icon-button type="button" (click)="copySensitiveField('tax_code')" [matTooltip]="'components.clinical-onboarding.clinician-detail.copy' | translate">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                    <button mat-icon-button type="button" (click)="hideSensitiveField('tax_code')" [matTooltip]="'components.clinical-onboarding.clinician-detail.hide' | translate">
                      <mat-icon>visibility_off</mat-icon>
                    </button>
                  } @else {
                    {{ (detail.engagement.has_tax_code ? 'generic.yes' : 'generic.no') | translate }}
                    @if (detail.engagement.has_tax_code) {
                      <button mat-icon-button type="button" [disabled]="revealingField !== null" (click)="revealSensitiveField('tax_code')" [matTooltip]="'components.clinical-onboarding.clinician-detail.reveal' | translate">
                        <mat-icon [class.spin]="revealingField === 'tax_code'">{{ revealingField === 'tax_code' ? 'autorenew' : 'visibility' }}</mat-icon>
                      </button>
                    }
                  }
                </span>
              </div>
              <div class="summary-field">
                <span class="summary-label">{{ 'components.clinical-onboarding.wizard.field-fiscal-regime' | translate }}</span>
                <span class="summary-value">
                  @if (detail.engagement.fiscal_regime) {
                    {{ 'components.clinical-onboarding.fiscal-regime.' + i18nKeySuffix(detail.engagement.fiscal_regime) | translate }}
                  } @else {
                    -
                  }
                </span>
              </div>
              <div class="summary-field">
                <span class="summary-label">{{ 'components.clinical-onboarding.clinician-detail.field-gross-amount' | translate }}</span>
                <span class="summary-value">{{ detail.engagement.gross_amount !== null ? (detail.engagement.gross_amount | number:'1.2-2') + ' EUR' : '-' }}</span>
              </div>
              <div class="summary-field">
                <span class="summary-label">{{ 'components.clinical-onboarding.clinician-detail.field-net-amount' | translate }}</span>
                <span class="summary-value">{{ detail.engagement.net_amount !== null ? (detail.engagement.net_amount | number:'1.2-2') + ' EUR' : '-' }}</span>
              </div>
              <div class="summary-field">
                <span class="summary-label">{{ 'components.clinical-onboarding.dashboard.column-net-amount' | translate }}</span>
                <span class="summary-value">{{ detail.engagement.net_amount_indicative !== null ? (detail.engagement.net_amount_indicative | number:'1.2-2') + ' EUR' : '-' }}</span>
              </div>
              @if (detail.engagement.payment && detail.engagement.is_paid) {
                <div class="summary-field">
                  <span class="summary-label">{{ 'components.clinical-onboarding.clinician-detail.field-payment' | translate }}</span>
                  <span class="summary-value">
                    {{ detail.engagement.payment.paid_amount !== null ? (detail.engagement.payment.paid_amount | number:'1.2-2') + ' EUR' : '-' }}
                    · {{ (detail.engagement.payment.payment_date | date:'dd/MM/yyyy') || '-' }}
                    @if (detail.engagement.payment.cro_reference) {
                      · CRO {{ detail.engagement.payment.cro_reference }}
                    }
                  </span>
                </div>
              }
              @if (detail.engagement.is_excluded && detail.engagement.exclusion_reason) {
                <div class="summary-field">
                  <span class="summary-label">{{ 'components.clinical-onboarding.clinician-detail.field-exclusion-reason' | translate }}</span>
                  <span class="summary-value">{{ detail.engagement.exclusion_reason }}</span>
                </div>
              }
              @if (detail.engagement.manual_participation_override) {
                <div class="summary-field">
                  <span class="summary-label">{{ 'components.clinical-onboarding.clinician-detail.field-override-reason' | translate }}</span>
                  <span class="summary-value">{{ detail.engagement.manual_override_reason || '-' }}</span>
                </div>
              }
            </div>

            <!-- Azioni di stato del gestore: pagamento (registra / modifica / annulla),
                 esclusione, forzatura della partecipazione. Stesse azioni del menu a tre
                 puntini della tabella. -->
            <div class="state-section">
              <h6 class="state-section-title">{{ 'components.clinical-onboarding.clinician-detail.payment-state-title' | translate }}</h6>
              <div class="state-section-actions">
                @if (detail.engagement.is_paid) {
                  <button mat-stroked-button color="primary" type="button" [disabled]="stateActionBusy" (click)="editPayment()">
                    <mat-icon class="mr-1">edit</mat-icon>
                    {{ 'components.clinical-onboarding.dashboard.action-edit-payment' | translate }}
                  </button>
                  <button mat-stroked-button color="warn" type="button" [disabled]="stateActionBusy" (click)="cancelPayment()">
                    <mat-icon class="mr-1">money_off</mat-icon>
                    {{ 'components.clinical-onboarding.dashboard.action-cancel-payment' | translate }}
                  </button>
                } @else {
                  <button mat-stroked-button color="primary" type="button" [disabled]="stateActionBusy || detail.engagement.is_excluded" (click)="registerPayment()">
                    <mat-icon class="mr-1">payments</mat-icon>
                    {{ 'components.clinical-onboarding.dashboard.action-mark-paid' | translate }}
                  </button>
                  <button mat-stroked-button color="primary" type="button" [disabled]="stateActionBusy" (click)="toggleExclusion()">
                    <mat-icon class="mr-1">{{ detail.engagement.is_excluded ? 'how_to_reg' : 'block' }}</mat-icon>
                    {{ (detail.engagement.is_excluded ? 'components.clinical-onboarding.dashboard.action-readmit' : 'components.clinical-onboarding.dashboard.action-exclude') | translate }}
                  </button>
                  <button mat-stroked-button color="primary" type="button" [disabled]="stateActionBusy" (click)="toggleParticipationOverride()">
                    <mat-icon class="mr-1">{{ detail.engagement.manual_participation_override ? 'flash_off' : 'flash_on' }}</mat-icon>
                    {{ (detail.engagement.manual_participation_override ? 'components.clinical-onboarding.dashboard.action-remove-override' : 'components.clinical-onboarding.dashboard.action-force-override') | translate }}
                  </button>
                }
              </div>
            </div>
          }
        </div>
      </mat-tab>

      <mat-tab [label]="'components.clinical-onboarding.wizard.step-documents' | translate">
        <div class="p-4">
          <div class="d-flex justify-content-end mb-3">
            <!-- DBEK-412: documento riservato a questo clinico, non comparirà mai
                 tra i "Documenti condivisi" della survey. -->
            <button mat-stroked-button color="primary" (click)="openAddDocument()">
              <mat-icon class="mr-1">add</mat-icon>
              {{ 'components.clinical-onboarding.clinician-detail.add-document' | translate }}
            </button>
          </div>
          @if (detail.documents.length === 0) {
            <div class="empty-documents">
              <mat-icon>folder_off</mat-icon>
              <span class="text-muted">{{ 'components.clinical-onboarding.wizard.no-documents-yet' | translate }}</span>
            </div>
          } @else {
            <div class="documents-list">
              @for (document of detail.documents; track document.id) {
                <div class="document-row">
                  <mat-icon color="primary">description</mat-icon>
                  <div class="document-info-text">
                    <span class="document-type">{{ document.title }}</span>
                    <!-- Audit UI/UX: stessi tag di ambito/tipologia gia' in uso nella
                         gestione "Documenti condivisi" (clinical-onboarding-document-
                         templates) - qui mancavano del tutto, il gestore doveva
                         ricordarsi/indovinare la natura del documento dal solo titolo. -->
                    <div class="document-tags">
                      <span class="document-tag">
                        {{ (document.scope === ClinicianDocumentTemplateScope.GENERIC
                          ? 'components.clinical-onboarding.document-templates.scope-generic'
                          : 'components.clinical-onboarding.document-templates.scope-per-candidate') | translate }}
                      </span>
                      <span class="document-tag">
                        {{ (document.requires_upload
                          ? 'components.clinical-onboarding.document-templates.requires-upload-true'
                          : 'components.clinical-onboarding.document-templates.requires-upload-false') | translate }}
                      </span>
                    </div>
                    <!-- Feedback utente: "non traccia chi ha visto i file che devono
                         essere anche restituiti" - viewed_at era gia' tracciato lato
                         backend ma invisibile qui: il gestore doveva aprire lo storico
                         attivita' e cercarlo. "Non ancora visto" evidenziato in giallo
                         se il clinico ha GIA' restituito un file senza mai aver aperto
                         l'originale - segnale utile che meritava di essere visibile. -->
                    <div class="document-hint text-muted small" [class.warning-hint]="document.requires_upload && document.returned_file_name && !document.viewed_at">
                      @if (document.viewed_at) {
                        {{ 'components.clinical-onboarding.clinician-detail.viewed-at' | translate: { date: (document.viewed_at | date:'dd/MM/yyyy HH:mm') } }}
                      } @else if (document.requires_upload) {
                        {{ 'components.clinical-onboarding.clinician-detail.not-viewed-yet' | translate }}
                      }
                    </div>
                    <!-- Audit UI/UX: il motivo dell'anomalia veniva chiesto al gestore
                         (ModalAddText, vedi ClinicalOnboardingDocumentStatusActionComponent)
                         e salvato, ma non era mai piu' mostrato da nessuna parte -
                         "scritto ma invisibile". -->
                    @if (document.status === ClinicianCandidateDocumentStatus.ANOMALY && document.anomaly_reason) {
                      <div class="document-hint anomaly-hint">
                        {{ 'components.clinical-onboarding.clinician-detail.anomaly-reason-hint' | translate: { reason: document.anomaly_reason } }}
                      </div>
                    }
                  </div>

                  <!-- Audit UI/UX: badge e bottoni condividevano lo stesso gap della
                       riga intera con icona/testo - un margine dedicato qui li
                       distingue chiaramente come un unico gruppo di azioni. -->
                  <div class="document-row-actions">
                    <app-clinical-onboarding-document-status-badge [status]="document.status"></app-clinical-onboarding-document-status-badge>

                    @if (document.can_view) {
                      <button mat-icon-button color="primary" [matTooltip]="'generic.view' | translate" (click)="viewDocument(document, 'source')">
                        <mat-icon>visibility</mat-icon>
                      </button>
                    } @else if (document.scope === ClinicianDocumentTemplateScope.PER_CANDIDATE) {
                      <input type="file" accept=".pdf" #sourceFileInput hidden (change)="onSourceFileSelected(document, $event)">
                      <button mat-stroked-button color="primary" [disabled]="uploadingDocumentId === document.id" (click)="sourceFileInput.click()">
                        @if (uploadingDocumentId === document.id) {
                          <mat-icon class="spin mr-1">autorenew</mat-icon>
                        } @else {
                          <mat-icon class="mr-1">upload</mat-icon>
                        }
                        {{ 'components.clinical-onboarding.clinician-detail.upload-source-file' | translate }}
                      </button>
                    }

                    @if (document.returned_file_name) {
                      <button mat-icon-button [matTooltip]="'components.clinical-onboarding.clinician-detail.view-returned-file' | translate" (click)="viewDocument(document, 'return')">
                        <mat-icon>find_in_page</mat-icon>
                      </button>
                    }
                    <!-- DBEK-411: l'azione (verifica/anomalia/invalida) serve
                         anche per un documento di sola visione gia' VIEWED,
                         non solo per quelli con un file restituito. -->
                    @if (document.status !== ClinicianCandidateDocumentStatus.PENDING) {
                      <app-clinical-onboarding-document-status-action
                        [surveyId]="data.surveyId"
                        [document]="document"
                        (statusChanged)="onDocumentStatusChanged(document, $event)"
                      ></app-clinical-onboarding-document-status-action>
                    }
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </mat-tab>

      <mat-tab [label]="'components.clinical-onboarding.clinician-detail.tab-activity' | translate">
        <div class="p-4">
          @if (activityLoading) {
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          } @else if (activityRows.length === 0) {
            <div class="empty-documents">
              <mat-icon>history</mat-icon>
              <span class="text-muted">{{ 'components.clinical-onboarding.clinician-detail.no-activity-yet' | translate }}</span>
            </div>
          } @else {
            <!-- Feedback utente: "lo storico attivita' nella UI c'e' bisogno di
                 filtri e ricerca" - tutto lato client, lo storico e' gia'
                 interamente caricato in una sola chiamata. -->
            <div class="activity-filters">
              <mat-form-field appearance="outline" class="activity-search-field" subscriptSizing="dynamic">
                <mat-icon matPrefix class="mr-1 text-muted">search</mat-icon>
                <input matInput [(ngModel)]="activitySearchTerm" [placeholder]="'generic.search-for' | translate">
                @if (activitySearchTerm) {
                  <button mat-icon-button matSuffix (click)="activitySearchTerm = ''" type="button">
                    <mat-icon>close</mat-icon>
                  </button>
                }
              </mat-form-field>

              <mat-form-field appearance="outline" class="activity-category-field" subscriptSizing="dynamic">
                <mat-select [(ngModel)]="activityCategoryFilter">
                  <mat-option [value]="ActivityCategories.ALL">{{ 'components.clinical-onboarding.clinician-detail.activity-category-all' | translate }}</mat-option>
                  <mat-option [value]="ActivityCategories.REGISTRATION">{{ 'components.clinical-onboarding.clinician-detail.activity-category-registration' | translate }}</mat-option>
                  <mat-option [value]="ActivityCategories.DOCUMENTS">{{ 'components.clinical-onboarding.clinician-detail.activity-category-documents' | translate }}</mat-option>
                  <mat-option [value]="ActivityCategories.PAYMENT">{{ 'components.clinical-onboarding.clinician-detail.activity-category-payment' | translate }}</mat-option>
                  <mat-option [value]="ActivityCategories.REMINDERS">{{ 'components.clinical-onboarding.clinician-detail.activity-category-reminders' | translate }}</mat-option>
                  <mat-option [value]="ActivityCategories.OTHER">{{ 'components.clinical-onboarding.clinician-detail.activity-category-other' | translate }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            @if (filteredActivityRows.length === 0) {
              <div class="empty-documents">
                <mat-icon>search_off</mat-icon>
                <span class="text-muted">{{ 'components.clinical-onboarding.clinician-detail.no-activity-matches' | translate }}</span>
              </div>
            } @else {
              <div class="activity-timeline">
                @for (row of filteredActivityRows; track $index) {
                  <div class="activity-row">
                    <mat-icon class="activity-icon">{{ row.icon }}</mat-icon>
                    <div class="activity-content">
                      <span class="activity-label">{{ row.i18nKey | translate: row.params }}</span>
                      <span class="activity-meta">
                        {{ row.created_at | date: 'dd/MM/yyyy HH:mm' }}
                        @if (row.actor_email) {
                          · {{ row.actor_email }}
                        }
                      </span>
                    </div>
                  </div>
                }
              </div>
            }
          }
        </div>
      </mat-tab>

      <!-- Note interne del gestore su questo candidato: piu' note, ciascuna con
           autore e data; mai visibili al clinico. -->
      <mat-tab [label]="('components.clinical-onboarding.clinician-detail.tab-notes' | translate) + (notesCount > 0 ? ' (' + notesCount + ')' : '')">
        <div class="p-4">
          <div class="note-composer">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
              <mat-label>{{ 'components.clinical-onboarding.clinician-detail.note-placeholder' | translate }}</mat-label>
              <textarea matInput rows="3" maxlength="5000" [(ngModel)]="newNoteBody" [disabled]="savingNote"></textarea>
            </mat-form-field>
            <div class="d-flex justify-content-between align-items-center mt-2">
              <small class="text-muted">{{ 'components.clinical-onboarding.clinician-detail.note-internal-hint' | translate }}</small>
              <button mat-raised-button color="primary" type="button" [disabled]="savingNote || !newNoteBody.trim()" (click)="addNote()">
                <mat-icon class="mr-1">add</mat-icon>
                {{ 'components.clinical-onboarding.clinician-detail.note-add' | translate }}
              </button>
            </div>
          </div>

          @if (notesLoading) {
            <mat-progress-bar mode="indeterminate" class="mt-3"></mat-progress-bar>
          } @else if (notes.length === 0) {
            <div class="empty-documents mt-3">
              <mat-icon>sticky_note_2</mat-icon>
              <span class="text-muted">{{ 'components.clinical-onboarding.clinician-detail.no-notes-yet' | translate }}</span>
            </div>
          } @else {
            <div class="notes-list mt-3">
              @for (note of notes; track note.id) {
                <div class="note-card">
                  <div class="note-header">
                    <mat-icon class="note-avatar">account_circle</mat-icon>
                    <div class="note-author">
                      <span class="note-author-name">{{ note.author_name || '-' }}</span>
                      <span class="note-meta">
                        @if (note.author_email && note.author_email !== note.author_name) {
                          {{ note.author_email }} ·
                        }
                        {{ note.created_at | date:'dd/MM/yyyy HH:mm' }}
                        @if (note.is_edited) {
                          · {{ 'components.clinical-onboarding.clinician-detail.note-edited-at' | translate: { date: (note.updated_at | date:'dd/MM/yyyy HH:mm') } }}
                        }
                      </span>
                    </div>
                    @if (editingNoteId !== note.id) {
                      <div class="note-actions">
                        @if (note.can_edit) {
                          <button mat-icon-button type="button" [matTooltip]="'generic.edit' | translate" (click)="startEditNote(note)">
                            <mat-icon>edit</mat-icon>
                          </button>
                        }
                        @if (note.can_delete) {
                          <button mat-icon-button type="button" [disabled]="deletingNoteId === note.id" [matTooltip]="'generic.remove' | translate" (click)="deleteNote(note)">
                            <mat-icon>delete_outline</mat-icon>
                          </button>
                        }
                      </div>
                    }
                  </div>

                  @if (editingNoteId === note.id) {
                    <mat-form-field appearance="outline" class="w-100 mt-2" subscriptSizing="dynamic">
                      <textarea matInput rows="3" maxlength="5000" [(ngModel)]="editingNoteBody" [disabled]="savingNote"></textarea>
                    </mat-form-field>
                    <div class="d-flex justify-content-end mt-2">
                      <button mat-stroked-button type="button" class="mr-2" [disabled]="savingNote" (click)="cancelEditNote()">{{ 'generic.buttons.cancel-and-back' | translate }}</button>
                      <button mat-raised-button color="primary" type="button" [disabled]="savingNote || !editingNoteBody.trim()" (click)="saveEditNote(note)">{{ 'generic.buttons.save' | translate }}</button>
                    </div>
                  } @else {
                    <p class="note-body">{{ note.body }}</p>
                  }
                </div>
              }
            </div>
          }
        </div>
      </mat-tab>
    </mat-tab-group>
  }
</mat-dialog-content>
